import { useState } from "react";
import { Share2, Link as LinkIcon, Check, MessageCircle, Facebook } from "lucide-react";
import { toast } from "sonner";

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2H21.5l-7.5 8.57L22.5 22h-6.9l-5.4-7.06L4 22H.74l8.02-9.17L.5 2h7.07l4.88 6.45L18.244 2zm-1.21 18h1.8L7.05 3.9H5.12L17.03 20z" />
  </svg>
);

export const ShareButtons = ({ title, text, url, variant = "light" }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const shareText = text || title || "Guarda questo su Flowerlive";
  const enc = encodeURIComponent;

  const links = [
    { id: "whatsapp", label: "WhatsApp", Icon: MessageCircle, href: `https://wa.me/?text=${enc(`${shareText} ${shareUrl}`)}` },
    { id: "facebook", label: "Facebook", Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(shareUrl)}` },
    { id: "x", label: "X", Icon: XIcon, href: `https://twitter.com/intent/tweet?text=${enc(shareText)}&url=${enc(shareUrl)}` }
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success("Link copiato!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Impossibile copiare il link");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, text: shareText, url: shareUrl }); } catch { /* cancelled */ }
    } else {
      copy();
    }
  };

  const dark = variant === "dark";
  const btn = `w-9 h-9 rounded-full flex items-center justify-center border transition-all hover:-translate-y-0.5 ${
    dark ? "border-white/30 text-white hover:bg-white hover:text-forest" : "border-cream-dark text-sage hover:border-brand hover:text-brand bg-white"
  }`;

  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <span className={`text-xs uppercase tracking-wider mr-1 ${dark ? "text-white/70" : "text-sage"}`}>Condividi</span>
      {links.map(({ id, label, Icon, href }) => (
        <a key={id} href={href} target="_blank" rel="noopener noreferrer" className={btn} title={`Condividi su ${label}`} data-testid={`share-${id}`}>
          <Icon className="h-4 w-4" />
        </a>
      ))}
      <button type="button" onClick={copy} className={btn} title="Copia link" data-testid="share-copy">
        {copied ? <Check className="h-4 w-4" /> : <LinkIcon className="h-4 w-4" />}
      </button>
      <button type="button" onClick={nativeShare} className={`${btn} sm:hidden`} title="Condividi" data-testid="share-native">
        <Share2 className="h-4 w-4" />
      </button>
    </div>
  );
};
